import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useIsNotDiscountTarget = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();

	const onSetIsNotDiscountTarget = useCallback(
		(input: boolean) => {
			onSetViewModel([
				{
					key: "isNotDiscountTarget",
					value: { isEdited: true, value: input },
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		isNotDiscountTarget: viewModel.isNotDiscountTarget,
		onSetIsNotDiscountTarget,
	};
};
